import { Directive, forwardRef, Attribute } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';

@Directive({
  selector: '[minimumAge][formControlName],[minimumAge][formControl],[minimumAge][ngModel]',
  providers: [{ provide: NG_VALIDATORS, useExisting: forwardRef(() => AgeValidator), multi: true }]
})
export class AgeValidator implements Validator {
  constructor(@Attribute('minimumAge') public minimumAge: number) {}
  

  validate(c: AbstractControl): { [key: string]: any } {
    // self value
    let _dobString = c.value;

    if (_dobString) {

      let dob = new Date(_dobString);
      let minAge = Number(this.minimumAge);
      let timeDiff = Math.abs(Date.now() - dob.getTime());
      let age = Math.floor((timeDiff / (1000 * 3600 * 24))/365.25);

      if (age < minAge) {
        return {
          minimumAge: false
        }
      }        
    }

    return null;

  }
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/_directive/age-validator.directive.ts